import React from "react";

export default (
  <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 1L5.99998 5.99998L1 11" stroke="white" strokeWidth="1.6" strokeLinecap="round"/>
  </svg>
);
